import { useEffect, useRef } from "react";

export function useItemChanged(callback: () => void) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let isHandlerAdded = false;
    let isUnmounted = false;

    const handler = (args?: any) => {
      callbackRef.current();
      args && args.completed && args.completed();
    };

    Office.onReady(() => {
      if (!Office.context?.requirements?.isSetSupported?.("Mailbox", "1.5")) {
        return;
      }

      Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, handler, (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          isHandlerAdded = true;
          if (isUnmounted) {
            // Type definitions don't include handler in options, but the runtime API supports it
            Office.context.mailbox.removeHandlerAsync(Office.EventType.ItemChanged, { handler } as any);
          }
        }
      });
    });

    return () => {
      isUnmounted = true;
      if (isHandlerAdded) {
        Office.context.mailbox.removeHandlerAsync(Office.EventType.ItemChanged, { handler } as any);
      }
    };
  }, []);
}
